import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import i18n from "utils/i18n";
import Text from "theme/Text";
import { StyleSheet } from "react-native";
import { setData } from "services/redux/data/actions";
import { colorList } from "utils/colors";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";
import HelperVersion from "utils/helper-version";
import { textStyles } from "styles/text";
import Button from "theme/Button";
import HelperSettingNotifications from "utils/helper-setting-notifications";
import ObjectEmployee from 'utils/objects/employee';
import HelperPlatform from 'utils/helper-platform';
import useStateWithCallback from 'use-state-with-callback'
import FetchCachedSettings from 'utils/fetch/cached/FetchCachedSettings'
import AppUpdater from 'services/app-updater'
import { openUrl } from 'utils/helper-url'

const NotificationsScene = () => {

	const dispatch = useDispatch()

	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} )
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const isOndmand = ObjectEmployee.isOndmand( _employee );

	const [ withTimer, setWithTimer ] = useState( false )
	const [ loading, setLoading ] = useState( false )

	const initialCountdown = 30;
	const [ countdown, setCountdown ] = useStateWithCallback( initialCountdown, ( currentCountdown ) => {
		setTimeout( countdownTimer, 1000 )
	} )

	const restartCountdownTimer = () => {
		setCountdown( initialCountdown )
	}

	const countdownTimer = () => {
		if( !withTimer ) {
			return;
		}

		const newCountdown = countdown - 1;

		if( newCountdown >= 0 ) {
			setCountdown( newCountdown )
			return;
		}

		// Call?
		FetchCachedSettings.reload({
			callbackSuccess: restartCountdownTimer,
			callbackError: restartCountdownTimer
		})
	}

	const onPressOpenUpdate = () => {
		if( HelperPlatform.isIOS() ) {
			openUrl( 'https://apps.apple.com/nl/app/my-office-days/id1529436910' );
			return;
		}

		openUrl( 'https://play.google.com/store/apps/details?id=nl.ondmand.myofficedays' );
	}

	const onPressIgnoreNotifications = () => {
		dispatch( setData( dataConstants.IGNORE_NOTIFICATIONS, true ) )

		HelperSettingNotifications.validate();
	}

	const onPressOtaUpdate = () => {
		const appUpdater = new AppUpdater();

		setLoading( true )

		appUpdater.fetch().then( () => {
			appUpdater.reload();
		});
	}

	useEffect( () => {
		countdownTimer();

		setWithTimer( HelperSetting.isYes( settingsConstants.MAINTENANCE ) )
	}, [ _settings, withTimer ] )

	let titleText = null;
	let descriptionText = null
	let countdownText = null;
	let button = null;

	switch( true ) {
		case HelperVersion.compareApp( HelperSetting.get( settingsConstants.NATIVE_APP_VERSION_REQUIREMENT ) ) === false:
			const appStore = HelperPlatform.isIOS() ? 'App Store' : 'Google play store';
			
			button = (
				<Button
					isLoading={ loading }
					onPress={ onPressOpenUpdate }>
					
					{ i18n.t( 'page.notifications.open_store', { store: appStore } ) }
				</Button>
			)
			
			titleText = i18n.t( 'page.notifications.app_update_required.title' );
			descriptionText = i18n.t( 'page.notifications.app_update_required.description', { store: appStore } );
			break;
			
		case HelperVersion.compareBuild( HelperSetting.get( settingsConstants.OTA_APP_VERSION_REQUIREMENT ) ) === false:
			button = (
				<Button
					isLoading={ loading }
					onPress={ onPressOtaUpdate }>

					{ i18n.t( 'pages.home.update.update_now' ) }
				</Button>
			)

			titleText = i18n.t( 'page.notifications.ota_update_required.title' );
			descriptionText = i18n.t( 'page.notifications.ota_update_required.description' );
			break;

		case HelperSetting.isYes( settingsConstants.MAINTENANCE ):
			titleText = i18n.t( 'page.notifications.maintenance.title' );
			descriptionText = i18n.t( 'page.notifications.maintenance.description' );
			countdownText = i18n.t( 'page.notifications.maintenance.countdown', { seconds: countdown } );
			break;
	}

	let ignoreButton = null;
	if( isOndmand ) {
		ignoreButton = (
			<Button
				appearance="ghost"
				onPress={ onPressIgnoreNotifications }>

				{ i18n.t( 'page.notifications.ignore') }
			</Button>
		)
	}

	const countdownStyle = [
		textStyles.textCenter,
		styles.reloading
	]

	const versionStyle = [
		textStyles.textCenter,
		styles.version
	]

	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				topNavigation={ true }
				showBackButton={ false }
				title={ titleText }>

				<ThemedBlock shadow mediumPadding>
					{ descriptionText !== null && (
						<Text style={ styles.description }>{ descriptionText }</Text>
					)}

					{ countdownText !== null && (
						<Text style={ countdownStyle }>{ countdownText }</Text>
					)}

					{ button !== null && button }

					<Text
						appearance={ "hint" }
						style={ versionStyle }>

						{ HelperVersion.get() }
					</Text>

					{ ignoreButton }
				</ThemedBlock>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export const styles = StyleSheet.create({
	description:{
		marginBottom: 32
	},
	reloading: {
		color: colorList.ORANGE.primary
	},
	version: {
		fontSize: 12,
		marginTop: 32
	}
})

export default NotificationsScene
